// import corporateLawImg from '../../images/services/corporate-law.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const CorporateLawAdvisory = () => {
  const serviceData = {
    title: "Corporate Law & Secretarial Advisory",
    heading: "Corporate Law & Secretarial Advisory",
    image: subTopicImages["Corporate Law & Secretarial Advisory"],
    intro: "End-to-End Corporate Legal & Secretarial Compliance Support",
    description: [
      "Businesses today operate in a complex corporate law environment. Every key business activity — whether it relates to shareholding, Board decisions, investments, restructuring, financing or governance — must be undertaken in line with the Companies Act and related legal provisions. Failure to follow the correct processes can create regulatory exposure for both the company and its directors.",
      "At V DOOGAR AND ASSOCIATES, we act as trusted advisors to Boards, promoters, senior management and foreign investors by providing practical, business-oriented corporate law advisory and secretarial support. Our focus is on ensuring that every corporate action is legally compliant, properly structured, clearly documented and professionally implemented.",
    ],
    services: [
      {
        title: "Corporate Secretarial Advisory Coverage",
        text: "Our Corporate Secretarial Advisory covers:",
        list: [
          "Companies Act advisory & interpretation",
          "corporate structuring & restructuring",
          "changes in directorships & key managerial personnel",
          "share capital issuance, buy-back & reclassification",
          "drafting statutory resolutions & governance documents",
          "advisory on shareholder rights & approvals",
          "legal compliance reviews & health-checks",
          "advisory during due diligence & corporate transactions",
        ],
        extraInfo: "",
      },
    ],
    benefitsIntro: "Our approach",
    benefits: [
      "understanding business objectives",
      "understanding shareholder interests",
      "understanding control and governance expectations",
      "understanding legal and regulatory impact",
      "recommending practical, compliant and commercially sound solutions",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default CorporateLawAdvisory;
